import {
  type DomainFormSchema,
  type DomainQuerySchema,
  strToHostingManagement,
  strToRegistrarManagement,
} from '../schemas';

export function domainQueryToForm(data: DomainQuerySchema): DomainFormSchema {
  return {
    ...data,
    dns_management: data.dns_management ?? '',
    deployment_path: data.deployment_path ?? '',
    registrar_management: strToRegistrarManagement(data.registrar_management),
    expiration_date: data.expiration_date ?? '',
    registrar_notes: data.registrar_notes ?? '',
    hosting_notes: data.hosting_notes ?? '',
    hosting_management: strToHostingManagement(data.hosting_management),
    registrar_username: data.registrar_username ?? '',
    registrar_password: data.registrar_password ?? '',
    registrar_pin: data.registrar_pin ?? '',
    registrar: data.registrar ?? null,
    infrastructure: data.infrastructure ?? null,
    client: data.client ?? null,
    application: data.application ?? null,
  };
}
